import { apiGetSealedItemStock } from './getSealedItemStock'

/**
 * 봉투 신청 가능 여부 (수량 무관) — 판매 중 && 재고 1개 이상.
 *
 * 수량 선택 전 단계(landing CTA·진입 분기)의 재고 신호로 사용.
 * 판정: `isOnSale=false` 또는 `stock<=0` → 신청 불가(soldOut), 그 외 → 통과.
 */
export const apiCheckSealedItemStock = async (): Promise<boolean> => {
  const { isOnSale, stock } = await apiGetSealedItemStock()
  return isOnSale && stock > 0
}
